export type RevealableResult = {
  hidden: boolean | string;
};

export function revealAccountResult(target: RevealableResult): void {
  target.hidden = false;
}
